let language = {
    HEADER_CATALOG_TEXT: "目录",
    HEADER_PRODUCT_TEXT: "产品",
    HEADER_CASE_STUDY:"案例学习",
    HEADER_CUSTOM_CARD:"自定义卡片",
    HEADER_CARD_GAME:"纸牌游戏",
    HEADER_TRADING_CARD_GAME:"集换式卡牌游戏 (TCG)",
    HEADER_CUSOM_PLAYING_CARDS:"定制扑克牌",
    HEADER_CUSTOM_TAROT_CARDS:"定制塔罗牌",
    HEADER_ORACLE_CARD:"神谕卡",
    HEADER_TRADINF_CARD:"收藏卡",
    HEADER_CUSTOM_PUZZLE:"定制拼图",
    HEADER_ART_AND_PHOTOGRAPHY:"艺术与摄影",
    HEADER_BLOG:"博客",
    HEADER_CONTACT_US:"联系我们",
    HEADER_PLATFORM:"平台",
    HEADER_PLATFORM_SHOPIFY:"Shopify",
    HEADER_PLATFORM_WOO:"WooCommerce",
    HEADER_PLATFORM_SNAPSHOP:"Snapshop",
    HEADER_SOLUTION:"产品",
    HEADER_TRADING_CARD:"交易卡",
    HEADER_SOLUTION_LICENSEE:"许可人",
    HEADER_SOLUTION_IP:"IP(知识产权)",
    HEADER_SIGN_UP:"注册",
    HEADER_SIGN_IN:"登录",
    HEADER_SIGN_OUT:"退出登录",
    HEADER_LOGIN:"登录",
    HEADER_DASHBOARD:"仪表板",
    HEADER_HOME_PAGE:"主页",
    HEADER_SELL_WITH_US:"批量订购",
    HEADER_BULK_ORDER_DISCOUNT:"批量订购折扣",
    HEADER_PREFERENCE_CURRENCY:"货币",
    HEADER_GET_USER_CURRENCY_ERROR_TITLE: "参数错误",
};

export { language }